import React from 'react';

export const Tooltip: React.FC = ({ children }) => (
  <div className="absolute inset-y-auto left-full h-full flex items-center">
    <div className="ml-6 shadow bg-gray-80 text-gray-10 body-small p-3 rounded-lg whitespace-nowrap">{children}</div>
  </div>
);
